require('./RASchemeSettingContribution.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @commons
const { AmountInput } = require('commonsComponents/amountInput');
const { OKDatePicker } = require('commonsComponents/OKDatePicker');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const RAContributionPeriodicity = require('../RAContributionPeriodicity/RAContributionPeriodicity');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLanguage } = require('core/i18n').i18n;

// @constants
const { EURO_SYMBOL } = require('constants/index');

const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_DATE_FORMAT,
    DATE_PICKER_CUSTOM_LOCALE,
} = require('constants/commonsComponents');
const {
    MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    MAXIMUM_OBJECTIVE_AMOUNT,
    MINIMUM_OBJECTIVE_AMOUNT,
    RA_DATEPICKER_MAXIMUM_YEARS,
} = require('../../raConstants/index');

class RASchemeSettingContribution extends React.Component {
    buildResetButton() {
        return (
            <div className="ra-scheme-setting-contribution__button">
                <OKButton
                    modifier="ghost"
                    size="small"
                    leftIcon="icon-limpiar_objetivo"
                    onClick={this.props.onResetClick}
                >
                    <FormattedText value="raGlobal-raGlobal_resetGoalButton" />
                </OKButton>
            </div>
        );
    }

    render() {
        const { immCustomPlanByObjective } = this.props;
        const objectiveAmount = immCustomPlanByObjective.get('objectiveAmount');
        let objectiveEndDate = immCustomPlanByObjective.get('objectiveEndDate');
        const initialContributionAmount = immCustomPlanByObjective.get(
            'initialContributionAmount',
        );
        const contributionAmount = immCustomPlanByObjective.get(
            'recurringContributionAmount',
        );
        const periodicity = immCustomPlanByObjective.get('periodicity');
        const contributionDay = immCustomPlanByObjective.get('contributionDay');
        const minDate = moment()
            .startOf('day')
            .add(1, 'day')
            .add(1, 'years');
        const maxDate = moment()
            .startOf('day')
            .add(RA_DATEPICKER_MAXIMUM_YEARS, 'years');
        const disableSelect = contributionAmount < 1;
        // verify selected date is not less than minDate
        objectiveEndDate =
            objectiveEndDate && objectiveEndDate.isSameOrAfter(minDate)
                ? objectiveEndDate
                : null;
        const injectedStrings = [MINIMUM_OBJECTIVE_AMOUNT];
        const resetButton = !!objectiveAmount ? this.buildResetButton() : null;

        return (
            <div className="ra-scheme-setting-contribution">
                <div className="ra-scheme-setting-contribution__content">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="ra-scheme-setting-contribution__amount-input">
                                <AmountInput
                                    amount={objectiveAmount}
                                    label={formatText(
                                        'raSchemeSettingContribution-objectiveAmount',
                                    )}
                                    min={0}
                                    max={MAXIMUM_OBJECTIVE_AMOUNT}
                                    fluid={true}
                                    hideFocusZero={true}
                                    language={getLanguage()}
                                    callback={ // eslint-disable-line
                                        this.props.onObjectiveAmountChange
                                    }
                                    error={immCustomPlanByObjective.get(
                                        'errorAmountMin',
                                    )}
                                    errorMsg={formatText(
                                        'rainput-amoutInputMinimumValidation',
                                        injectedStrings,
                                    )}
                                />
                                <span className="ra-scheme-setting-contribution__amount-input-symbol">
                                    {EURO_SYMBOL}
                                </span>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="ra-scheme-setting-contribution__date-picker">
                                <div className="ra-scheme-setting-contribution__date-picker-label">
                                    {formatText(
                                        'raSchemeSettingContribution-objectiveEndDate',
                                    )}
                                </div>
                                <div key={objectiveEndDate === null}>
                                    <OKDatePicker
                                        locale={formatText(
                                            DATE_PICKER_CUSTOM_LOCALE,
                                        )}
                                        callback={ // eslint-disable-line
                                            this.props.onObjectiveEndDateChange
                                        }
                                        callbackError={ // eslint-disable-line
                                            this.props.onObjectiveEndDateError
                                        }
                                        dateFormat={formatText(
                                            DATE_PICKER_CUSTOM_DATE_FORMAT,
                                        )}
                                        maxDate={maxDate}
                                        messageLessThanMinDateError={formatText(
                                            'raDatePicker-raDatePicker_lessThanMinDateError',
                                        )}
                                        messageMoreThanMinDateError={formatText(
                                            'raDatePicker-raDatePicker_moreThanMaxDateError',
                                        )}
                                        messageStandardErrorDate={formatText(
                                            'raDatePicker-raDatePicker_standardDateError',
                                        )}
                                        minDate={minDate}
                                        newSelectedDate={objectiveEndDate}
                                        placeholder={formatText(
                                            DATE_PICKER_CUSTOM_PLACEHOLDER,
                                        )}
                                        selectedDate={objectiveEndDate}
                                        startDate={minDate}
                                        defaultPlaceholder={formatText(
                                            'datePickerCustom-defaultPlaceholder',
                                        )}
                                        defaultPlaceholderDay={formatText(
                                            'datePickerCustom-defaultPlaceholderDay',
                                        )}
                                        defaultPlaceholderMonth={formatText(
                                            'datePickerCustom-defaultPlaceholderMonth',
                                        )}
                                        defaultPlaceholderYear={formatText(
                                            'datePickerCustom-defaultPlaceholderYear',
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="ra-scheme-setting-contribution__amount-input">
                                <AmountInput
                                    amount={initialContributionAmount}
                                    label={formatText(
                                        'raSchemeSettingContribution-initialInvestment',
                                    )}
                                    min={0}
                                    max={
                                        MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT
                                    }
                                    fluid={true}
                                    hideFocusZero={true}
                                    language={getLanguage()}
                                    callback={ // eslint-disable-line
                                        this.props.onInitialContributionChange
                                    }
                                    error={immCustomPlanByObjective.get(
                                        'errorInitialMin',
                                    )}
                                    errorMsg={formatText(
                                        'rainput-amoutInputMinimumValidation',
                                        injectedStrings,
                                    )}
                                />
                                <span className="ra-scheme-setting-contribution__amount-input-symbol">
                                    {EURO_SYMBOL}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ra-scheme-setting-contribution__info">
                                <FormattedText
                                    className="ra-scheme-setting-contribution__primary-info"
                                    value="raSchemeSettingContribution-primaryInfo"
                                />
                                <FormattedText
                                    className="ra-scheme-setting-contribution__secondary-info"
                                    value="raSchemeSettingContribution-secondaryInfo"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <RAContributionPeriodicity
                                amount={contributionAmount}
                                hideFocusZero={true}
                                selectedDay={contributionDay}
                                selectedPeriodicity={periodicity}
                                onDayClick={this.props.onContributionDayChange}
                                onPeriodicityChange={
                                    this.props.onPeriodicityChange
                                }
                                onRecurringContributionChange={
                                    this.props.onRecurringContributionChange
                                }
                                disableSelect={disableSelect}
                                errorState={immCustomPlanByObjective.get(
                                    'errorPeriodicityMin',
                                )}
                                errorMessage={formatText(
                                    'raHireManagementPlanStep2-errorMessage',
                                )}
                            />
                        </div>
                    </div>
                </div>
                {resetButton}
            </div>
        );
    }
}

RASchemeSettingContribution.propTypes = {
    immCustomPlanByObjective: PropTypes.object.isRequired,
    onContributionDayChange: PropTypes.func.isRequired,
    onInitialContributionChange: PropTypes.func.isRequired,
    onObjectiveAmountChange: PropTypes.func.isRequired,
    onObjectiveEndDateChange: PropTypes.func.isRequired,
    onObjectiveEndDateError: PropTypes.func.isRequired,
    onPeriodicityChange: PropTypes.func.isRequired,
    onRecurringContributionChange: PropTypes.func.isRequired,
    onResetClick: PropTypes.func.isRequired,
};

RASchemeSettingContribution.defaultProps = {};

module.exports = RASchemeSettingContribution;
